<mat-tab-group style="width: 200px" #tabGroup>
  <ng-content #outlet></ng-content>
</mat-tab-group>
